import { StyleSheet } from 'react-native';
export var getPackDetailsWidgetStyles = props => {
  var title = props.title,
    subTitle = props.subTitle,
    ctaText = props.ctaText;
  var showTopContainer = title || subTitle || ctaText;
  return StyleSheet.create({
    container: {
      paddingHorizontal: 0,
      paddingTop: showTopContainer ? 0 : 8,
      paddingBottom: 8
    },
    topContainer: {
      paddingHorizontal: 17,
      paddingTop: 16,
      paddingBottom: 9
    },
    cta: {
      marginTop: 12,
      alignSelf: 'flex-start'
    },
    subTitle: {
      marginTop: 4
    }
  });
};